import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b7522bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq" }
const _hoisted_2 = { class: "container-lg container-fluid py-lg-5 py-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-primary mb-4" }, "Frequently Asked Questions", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-2 col-12" }
const _hoisted_6 = { class: "nav flex-md-column mb-3 mt-2" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-md-10 col-12" }
const _hoisted_9 = {
  class: "accordion",
  id: "faq"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = ["id", "aria-labelledby"]
const _hoisted_13 = { class: "accordion-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sideLink, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass([item === _ctx.activeTitle ? 'active' : '']),
                  onClick: ($event: any) => (_ctx.onChange(item))
                }, _toDisplayString(item), 11, _hoisted_7))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtered, (data, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "accordion-item"
              }, [
                _createElementVNode("h2", {
                  class: "accordion-header",
                  id: i
                }, [
                  _createElementVNode("button", {
                    class: "accordion-button collapsed",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#collapse-${i}`,
                    "aria-expanded": "false",
                    "aria-controls": `collapse-${i}`
                  }, _toDisplayString(data.title), 9, _hoisted_11)
                ], 8, _hoisted_10),
                _createElementVNode("div", {
                  id: `collapse-${i}`,
                  class: "accordion-collapse collapse",
                  "aria-labelledby": data.title,
                  "data-bs-parent": "#faq"
                }, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(data.body), 1)
                ], 8, _hoisted_12)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}